// extracted by mini-css-extract-plugin
export var orderSummary = "_nm-0";
export var showMoreLessButton = "_nm-1";